export const PowoPdfOpenApi = `${process.env.REACT_APP_API_URL}/po-pdf/`;

export const PowoDeliveryChallanOpenApi =
  `${process.env.REACT_APP_API_URL}/po-delivery-challan/`;
